export const categories = [
  {
    slug: 'forex-basics',
    name: 'Forex พื้นฐาน',
    tagline: 'เริ่มจากศูนย์ให้เข้าใจตลาด',
    description:
      'ปูพื้นฐาน Forex ตั้งแต่ Forex คืออะไร คู่เงิน Pip Spread Leverage และ Margin อธิบายด้วยภาษาง่าย ๆ สำหรับมือใหม่ที่เพิ่งเริ่มสนใจตลาดแลกเปลี่ยนเงินตรา',
    audience: [
      'เพิ่งเริ่มสนใจตลาด Forex และยังไม่คุ้นกับศัพท์พื้นฐาน',
      'อยากเข้าใจ Pip, Spread, Leverage ให้ชัดก่อนลงเงินจริง',
      'มีพอร์ตทดลองแล้ว แต่ยังอ่านกราฟกับคู่เงินไม่ออก',
    ],
    icon: 'ri-book-open-line',
    outcomes: [
      { title: 'อธิบายได้ว่า Forex คืออะไร และกำไรมาจากส่วนต่างตรงไหน', slug: 'what-is-forex' },
      { title: 'อ่านคู่เงินและแยก Major / Minor / Exotic ได้', slug: 'currency-pairs' },
      { title: 'คำนวณ Pip กับ Spread เพื่อรู้ต้นทุนต่อออเดอร์', slug: 'what-is-pip' },
      { title: 'เข้าใจ Leverage กับ Margin และรู้ว่าพอร์ตรับแรงได้แค่ไหน', slug: 'what-is-leverage' },
    ],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20financial%20education%20illustration%20soft%20teal%20gradient%20waves%20with%20warm%20orange%20accent%20lines%20on%20clean%20light%20background%20editorial%20flat%20design%20subtle%20grid%20texture%20no%20text%20harmonious%20composition&width=1200&height=675&seq=cat-basics-01&orientation=landscape',
  },
  {
    slug: 'forex-trading',
    name: 'วิธีเทรด Forex',
    tagline: 'จากแผนสู่การเปิดออเดอร์จริง',
    description:
      'เรียนรู้วิธีเทรด Forex ตั้งแต่เลือกคู่เงินและวิเคราะห์ตลาด ไปจนถึงการเลือกประเภทคำสั่ง เปิดออเดอร์ ปิดสถานะ และอ่านต้นทุนการเทรดอย่าง Spread กับสลิปเพจ',
    audience: [
      'เข้าใจพื้นฐานแล้ว และอยากเริ่มเปิดออเดอร์จริงอย่างเป็นขั้นตอน',
      'เคยเปิดออเดอร์แล้วขาดทุน เพราะยังไม่มีแผนก่อนกด',
      'ไม่แน่ใจว่าควรใช้คำสั่ง Market, Limit หรือ Stop ในสถานการณ์ไหน',
    ],
    icon: 'ri-line-chart-line',
    outcomes: [
      { title: 'วางแผนเทรดครบ 6 ขั้นตอน ตั้งแต่เลือกคู่เงินจนปิดออเดอร์', slug: 'how-to-trade-forex' },
      { title: 'ประเมิน Spread สลิปเพจ และเวลาเทรดก่อนกดทุกออเดอร์', slug: 'forex-execution-cost' },
      { title: 'เลือกคำสั่ง Market / Limit / Stop ให้ตรงกับแผนที่วางไว้', slug: 'forex-order-types' },
      { title: 'เปิดออเดอร์ Buy / Sell พร้อมจุดเข้าและ Stop Loss ได้ถูกขั้นตอน', slug: 'how-to-place-order' },
      { title: 'ปิดออเดอร์เต็มจำนวนหรือทยอยปิดบางส่วนได้ตามแผน', slug: 'closing-forex-positions' },
    ],
    image:
      'https://readdy.ai/api/search-image?query=Clean%20modern%20trading%20workflow%20concept%20illustration%20with%20teal%20step%20blocks%20and%20amber%20highlight%20minimal%20geometric%20shapes%20light%20background%20editorial%20infographic%20style%20no%20text%20high%20detail&width=1200&height=675&seq=cat-trading-01&orientation=landscape',
  },
  {
    slug: 'mt4-mt5',
    name: 'MT4 / MT5',
    tagline: 'คู่มือใช้แพลตฟอร์มเทรดยอดนิยม',
    description:
      'คู่มือการใช้งาน MetaTrader 4 และ MetaTrader 5 สำหรับผู้เริ่มต้น ตั้งแต่การติดตั้ง การเปิดกราฟ การเพิ่มคู่เงิน การเปิดออเดอร์ ไปจนถึงการตั้ง Stop Loss และ Take Profit พร้อมตารางเปรียบเทียบว่า MT4 กับ MT5 ต่างกันตรงไหน',
    audience: [
      'เพิ่งเปิดบัญชีและยังไม่คุ้นกับหน้าจอ MetaTrader',
      'ติดตั้งแพลตฟอร์มไม่สำเร็จ หรือหาคู่เงินใน Market Watch ไม่เจอ',
      'อยากเปิดและปิดออเดอร์ด้วยตัวเองโดยไม่ต้องให้ใครช่วย',
    ],
    icon: 'ri-computer-line',
    outcomes: [
      { title: 'ติดตั้งและตั้งค่า MT4 จนเริ่มดูกราฟได้ด้วยตัวเอง', slug: 'mt4-guide' },
      { title: 'ติดตั้งและตั้งค่า MT5 พร้อมใช้งานครบทุกขั้นตอน', slug: 'mt5-guide' },
      { title: 'แยกความต่าง MT4 กับ MT5 แล้วเลือกให้ตรงกับสิ่งที่อยากเทรด', slug: 'mt4-vs-mt5' },
      { title: 'เช็ก Spread บนแพลตฟอร์มก่อนกดออเดอร์ทุกครั้ง', slug: 'how-to-check-spread-mt4' },
      { title: 'เปิดออเดอร์บน MT5 ได้เองโดยไม่ต้องให้ใครช่วย', slug: 'how-to-place-order-mt5' },
    ],
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20abstract%20trading%20platform%20interface%20concept%20with%20teal%20candlestick%20chart%20panels%20and%20warm%20orange%20accents%20on%20light%20clean%20background%20flat%20editorial%20design%20no%20text%20no%20people&width=1200&height=675&seq=cat-mt-01&orientation=landscape',
  },
  {
    slug: 'forex-analysis',
    name: 'วิเคราะห์ Forex',
    tagline: 'อ่านกราฟและจับทิศทางตลาด',
    description:
      'เรียนการวิเคราะห์ Forex ทั้ง Price Action Technical Indicators อย่าง RSI MACD Moving Average และแนวรับแนวต้าน เพื่อช่วยตัดสินใจก่อนเปิดสถานะ',
    audience: [
      'อยากตัดสินใจจากกราฟด้วยตัวเอง ไม่ใช่ตามคำบอกต่อ',
      'ใช้อินดิเคเตอร์เป็น แต่ยังอ่านพฤติกรรมราคาไม่ออก',
      'ต้องการวางจุดเข้าและจุดออกให้แม่นขึ้นก่อนกดออเดอร์',
    ],
    icon: 'ri-bar-chart-2-line',
    outcomes: [
      { title: 'อ่านกราฟเทคนิคและเลือกไทม์เฟรมให้เหมาะกับแผนเทรด', slug: 'forex-technical-analysis' },
      { title: 'อ่านพฤติกรรมราคาแบบ Price Action โดยไม่ต้องพึ่งอินดิเคเตอร์', slug: 'price-action' },
      { title: 'ใช้ RSI / MACD / Moving Average เป็นตัวยืนยันจังหวะเข้า', slug: 'technical-indicators' },
      { title: 'วางแนวรับแนวต้านและกำหนดจุดเข้า-ออกได้เอง', slug: 'support-resistance' },
    ],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20candlestick%20chart%20analysis%20illustration%20teal%20and%20soft%20grey%20candles%20with%20amber%20trend%20line%20on%20light%20background%20minimal%20fintech%20editorial%20style%20no%20text%20no%20people&width=1200&height=675&seq=cat-analysis-01&orientation=landscape',
  },
  {
    slug: 'risk-management',
    name: 'การบริหารความเสี่ยง',
    tagline: 'อยู่รอดในตลาดได้นานกว่าใคร',
    description:
      'เข้าใจการบริหารความเสี่ยงก่อนตัดสินใจเปิดสถานะ ตั้งแต่ Risk per Trade ขนาดสถานะ Risk Reward Ratio ไปจนถึง Drawdown เพื่อเทรดอย่างมีวินัยและปลอดภัย',
    audience: [
      'เคยขาดทุนหนัก เพราะไม่ได้จำกัดความเสี่ยงต่อออเดอร์',
      'อยากคำนวณขนาดล็อตให้พอดีกับพอร์ตที่มีอยู่',
      'ต้องการกติกาชัดเจน เพื่อให้เทรดได้สม่ำเสมอในระยะยาว',
    ],
    icon: 'ri-shield-check-line',
    outcomes: [
      { title: 'กำหนดความเสี่ยงต่อออเดอร์และกติกาส่วนตัวได้', slug: 'risk-management-basics' },
      { title: 'คำนวณขนาดสถานะจากความเสี่ยงที่รับได้และระยะ Stop Loss', slug: 'position-sizing' },
      { title: 'ประเมิน Risk Reward ก่อนเปิดออเดอร์ทุกครั้ง', slug: 'risk-reward-ratio' },
      { title: 'รับมือ Drawdown และป้องกันไม่ให้พอร์ตเสียหายหนัก', slug: 'drawdown' },
    ],
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20abstract%20risk%20management%20dashboard%20concept%20teal%20gauge%20and%20amber%20warning%20accents%20light%20clean%20background%20editorial%20flat%20design%20subtle%20grid%20no%20text&width=1200&height=675&seq=cat-risk-01&orientation=landscape',
  },
];